import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import * as yup from "yup";
import axiosInstance from "../../../services/axiosComman";
import { handleKeyDown } from "../../../utils/OtherFunctions";
import { CancelButton, SubmitButton } from "../../../utils/Button";
import { NuInput } from "../../../utils/Inputs";
import { CloseIcon } from "../../../assets/icons";
import { toast } from "react-toastify";


export default function CreateorUpdate({
  data,
  visible,
  onClose,
  refreshData,
  id,
}) {
  const [isLoading, setIsLoading] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [show, setShow] = useState(false);
  const [createNew, setCreateNew] = useState({
    server_name: "",
    port: "",
    useremail: "",
    passwordOrAuthkey: "",
  });

  useEffect(() => {
    setCreateNew({
      companyName: data?.companyName,
      address: data?.address,
      email: data?.email,
      mobile: data?.mobile,
      companyWebsite: data?.companyWebsite,
      country: data?.country,
      city: data?.city,
      server_name: data?.server_name,
      port: data?.port,
      useremail: data?.useremail,
      passwordOrAuthkey: data?.passwordOrAuthkey,
    });
  }, [data]);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: createNew,
    validateOnChange: false,
    validateOnBlur: false,
    validationSchema: yup.object({}),
    onSubmit: (value, { resetForm }) => {
      setIsLoading(true);
      if (data?.id) {
        axiosInstance
          .put(`/server_email/${data?.id}`, value)
          .then((res) => {
            if (res.data) {
              setIsLoading(false);
              resetForm();
              refreshData();
              onClose();
              toast.success(<p className="test-sm">{`${res.data.msg||res.data.message}`||"Data Updated Successfully"}</p>,)
            } else {
              setIsLoading(false);
              toast.error(<p className="test-sm">{`${res.data.msg||res.data.message}`||"Data Updated Unsuccessfully"}</p>,)
            }
          })
          .catch((err) => {
            setIsLoading(false);
            toast.error(<p className="test-sm">{`${err?.response?.data.msg||err?.response?.data.message||err?.response?.data.error||"Data Updated Unsuccessfully"}`}</p>,)
          });
      } else {
        axiosInstance
          .post(`/server_email/`, value)
          .then((res) => {
            if (res.data) {
              setIsLoading(false);
              refreshData();
              resetForm();
              onClose();
              toast.success(<p className="test-sm">{`${res.data.msg||res.data.message}`||"Data Added Successfully"}</p>,)
            } else {
              setIsLoading(false);
              toast.error(<p className="test-sm">{`${res.data.msg||res.data.message}`||"Data Added Unsuccessfully"}</p>,)
            }
          })
          .catch((err) => {
            setIsLoading(false);
            toast.error(<p className="test-sm">{`${err?.response?.data.msg||err?.response?.data.message||err?.response?.data.error||"Data Added Unsuccessfully"}`}</p>,)
          });
      }
    },
  });

  const resetClose = ()=>{
    formik.resetForm()
    onClose()
  }

  if (!visible) return null;
  return (
    <>
      <div
        id="modal"
        // onClick={handleOnClose}
        className="bg-black bg-opacity-30 fixed z-10 inset-0 backdrop-blur-sm 
        flex justify-center items-center "
      >
        <div className="bg-white mt-8 max-h-[55vh] overflow-hidden p-2 rounded-xl w-6/12">
          <div className="flex items-start justify-between px-5 py-2  rounded-t">
            <h3 className="text-base 2xl:text-lg font-semibold">
              {data ? "Edit" : "New"}
            </h3>
            <span
              className="h-6 w-6 text-2xl block cursor-pointer"
              onClick={resetClose}
            >
                <CloseIcon/>
            </span>
          </div>
          <form onSubmit={formik.handleSubmit} onKeyDown={handleKeyDown}>
            <div className="overflow-y-auto  max-h-[45vh]">
              <div className="relative px-6 flex flex-wrap justify-between">
                <NuInput
                  formik={formik}
                  name="server_name"
                  label="Server Name"
                  width="w-1/2"
                  placeholder="Server Name"
                />
                <NuInput
                  formik={formik}
                  name="port"
                  label="Port"
                  width="w-1/2"
                  placeholder="Port"
                />
                <NuInput
                  formik={formik}
                  name="useremail"
                  label="Email / User Name"
                  width="w-1/2"
                  placeholder="Email / User Name"
                />
                <NuInput
                  formik={formik}
                  name="passwordOrAuthkey"
                  label="Password / Auth Key"
                  width="w-1/2"
                  placeholder="Password / Auth Key"
                  type={show==true?"text":"password"}
                />
              </div>
              <div className=" w-full flex justify-end">
                <div className=" w-1/2 px-6">
                  <input
                    type="checkbox"
                    onChange={(e) => setShow(e.target.checked)}
                  />
                  <span className=" text-xs ml-2">
                    Show Password / Auth Key
                  </span>
                </div>
              </div>
              <div className=" w-full flex items-center justify-end px-6 py-6 rounded-b text-xs 2xl:text-sm">
                <CancelButton onClose={resetClose} isLoading={isLoading} />
                <SubmitButton isLoading={isLoading} />
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
}
